module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_7016.bdc04e83.png";